import { render, staticRenderFns } from "./StaffBilling.vue?vue&type=template&id=1e7073b6&scoped=true&"
import script from "./StaffBilling.vue?vue&type=script&lang=ts&setup=true&"
export * from "./StaffBilling.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./StaffBilling.vue?vue&type=style&index=0&id=1e7073b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7073b6",
  null
  
)

export default component.exports